import { render, staticRenderFns } from "./ProduktDetails.vue?vue&type=template&id=48c04ece&scoped=true&"
import script from "./ProduktDetails.vue?vue&type=script&lang=js&"
export * from "./ProduktDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProduktDetails.vue?vue&type=style&index=0&id=48c04ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c04ece",
  null
  
)

component.options.__file = "ProduktDetails.vue"
export default component.exports